import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import PenilaianRepository from '../Repositories/PenilaianRepository'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/penilaian360Service'


class PenilaianBloc
{
    repository = new PenilaianRepository()
    recapPeriodComponentChannel = new Subject()

    constructor(){
        this.recapPeriodComponentChannel.next({status: apiResponse.INITIAL})
    }

    fetchRecapComponent = async (query) => {
        this.recapPeriodComponentChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRecapComponent(query).then((result) => {
            this.recapPeriodComponentChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.recapPeriodComponentChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

}


export default PenilaianBloc